import useCurrentLayout from '@/hooks/layout/useCurrentLayout';

// Hook to calculate how many loading items we should have on the end
// of a list when loading more items for the list
const useLoadingMoreCount = ({
  sizeCountMap,
  listLength = 0
}) => {
  const { width } = useCurrentLayout();
  
  // How many items are there per row in the list?
  const objectForScreenSize = sizeCountMap.find(({ min, max }) => (
    (min || max)
    && (min ? (width >= min) : true)
    && (max ? (width <= max) : true)
  )) || {};
  const countForScreenSize = objectForScreenSize.count || 3;
  // How many items are in the last row in the list?
  const countInFinalRow = objectForScreenSize.count
    ? ((listLength || 0) % countForScreenSize)
    : countForScreenSize;
  // The loadingMoreCount should fill the spare space in the final row + one more row
  const loadingMoreCount = countForScreenSize
    + (
      countInFinalRow
        ? (countForScreenSize - countInFinalRow)
        : 0
    );

  return {
    countForScreenSize,
    loadingMoreCount
  };
};

export default useLoadingMoreCount;